import type * as AffiliateStepsCards from '../types/AffiliateStepsCards'

export default function affiliateStepsCardsComponentParser(
  rawComponent: AffiliateStepsCards.Raw,
): AffiliateStepsCards.Parsed {
  return {
    name: 'AffiliateStepsCards',
    props: {
      cards: rawComponent.stepCards,
    },
  }
}
